import type { RouteListItem } from '@/types';

import { type PaymentMethodFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<PaymentMethodFormSchema> = {
  id: -1,
  name: '',
  is_active: true,
  include_for_taking_tender: true,
  include_for_manual_deposit: false,
  payment_method_fields: [],
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/payment-methods', name: 'Payment Methods' },
];
